<div>
    <p class="hidden">v0.0.3 cache-bust</p>
  <!-- riga 1: Ecomic pre-header + toolbar — iniettata da /toolbar.js nel <header> -->

  <!-- riga 2: Logo, Title, Navbar, Pulsante -->
  <div class="bg-navbar">
    <div class="mx-auto w-[min(1280px,100%_-_2rem)]">
      <div class="h-20 navbar-row">
        <!-- Logo e Titolo (No Wrap) -->
        <div class="flex items-center gap-6 min-w-0 navbar-brand">
          <div class="flex items-center gap-6.25 navbar-brand-mark">
            <img [src]="logoNavbar()" alt="Logo Ecomic - Ecosistema digitale per la cultura" class="navbar-app-logo navbar-app-logo--desktop" />
            <img [src]="mobileLogoIcon" alt="Logo Ecomic - Ecosistema digitale per la cultura" class="navbar-app-logo navbar-app-logo--mobile" />
            <div class="navbar-app-divider" aria-hidden="true"></div>
          </div>
          <div class="flex items-center min-w-0 navbar-brand-title">
            <a [routerLink]="homeRoute" class="navbar-brand-link">
              <p class="font-normal main-title">
                Mappa del patrimonio
              </p>
            </a>

          </div>

        </div>

        <!-- Navbar Elements — allineati a sinistra, distanza dal titolo via gap riga -->
        <nav class="min-w-0 navbar-desktop-nav navbar-nav-wrap" aria-label="Navigazione principale">
          <ul class="flex flex-row items-center gap-6 m-0 p-0 list-none navbar-nav">
            @for (item of navItems(); track item.path) {
              @if(item.loggedIn === true) {
                <li class="nav-item">
                  <a
                    class="font-light text-gray-700 hover:text-purple-700 nav-link"
                    [routerLink]="item.path"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: item.exact === true }"
                  >
                    {{ item.label }}
                  </a>
                </li>
              }
            }
          </ul>
        </nav>

        <!-- Pulsante Area Riservata — nascosto su mobile -->
        <div class="shrink-0 navbar-desktop-nav navbar-actions">
          <div class="inline-block relative">
            <dpac-button
              [classe]="buttonClasse()"
              [label]="buttonLabel()"
              [menuOptions]="menuOptions()"
              (onOptionSelect)="onMenuOptionSelect($event)">
            </dpac-button>
            @if (isIamOnlyUser()) {
              <span class="iam-badge" title="Completa la registrazione">?</span>
            }
          </div>
        </div>

        <!-- Hamburger (mobile only) -->
        <div class="navbar-mobile-hamburger shrink-0">
          <button
            type="button"
            class="mobile-menu-btn"
            [attr.aria-expanded]="mobileMenuOpen()"
            [attr.aria-label]="mobileMenuOpen() ? 'Chiudi menu di navigazione' : 'Apri menu di navigazione'"
            (click)="toggleMobileMenu()"
          >
            <span class="mobile-bar" [class.bar-open]="mobileMenuOpen()"></span>
            <span class="mobile-bar" [class.bar-open]="mobileMenuOpen()"></span>
            <span class="mobile-bar" [class.bar-open]="mobileMenuOpen()"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
